module.exports = __webpack_public_path__ + "static/media/techCrunch.1e470812.svg";